import { render, staticRenderFns } from "./PersistCargaDestinatarioView.vue?vue&type=template&id=5ba33e3a&"
import script from "./PersistCargaDestinatarioView.vue?vue&type=script&lang=ts&"
export * from "./PersistCargaDestinatarioView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports